import { useQuery } from '@apollo/client/react';

import { gql } from 'src/__generated__';

export const GET_CAREER_HISTORY = gql(`
  query GetRoles {
    viewer {
      _id
      roles {
        ...role
      }
    }
  }
`);
export function useCareerHistoryData() {
  const { data: rolesData, loading } = useQuery(GET_CAREER_HISTORY);
  const roles = rolesData?.viewer?.roles || [];

  return { roles, loading };
}
